import dateLib from '~/helper/Util/datelib'

export default ({ app }, inject) => {
	inject('_date', dateLib)
}
